<script setup>
import { computed } from 'vue'

const props = defineProps({
  rating: Object,
  size: {
    type: String,
    default () {
      return 'md'
    }
  },
})

const stars = computed(() => {
  const stars = []
  const full = Math.floor(props.rating.rating)
  const half = props.rating.rating % 1 >= 0.25 && props.rating.rating % 1 < 0.75
  for (let i = 0; i < 5; i++) {
    if (i < full) {
      stars.push('full')
    } else if (i === full && half) {
      stars.push('half')
    } else {
      stars.push('empty')
    }
  }
  return stars
})

const sizes = {
  'xs': 'size-3',
  'md': 'size-5',
  'lg': 'size-7',
}
</script>

<template>
    <a :href="rating.link" class="inline-flex items-center gap-2" target="_blank">
        <svg class="size-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
            <path d="M1 1h22v22H1z" fill="none"/>
        </svg>
        <div class="flex items-center gap-0.2">
            <template v-for="star in stars">
                <svg v-if="star === 'full'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-5 text-yellow-400" :class="[ sizes[size] ]">
                    <path fill-rule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z" clip-rule="evenodd" />
                </svg>
                <svg v-if="star === 'empty'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-5 text-gray-100">
                    <path fill-rule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z" clip-rule="evenodd" />
                </svg>
                <span v-if="star === 'half'" class="flex px-[1px]">
                    <svg viewBox="0 0 10 19" xmlns="http://www.w3.org/2000/svg" class="h-4 w-auto fill-yellow-400">
                      <path fill-rule="evenodd" d="M10.0008046,0.00319143673 L10,16.008 L9.90771735,15.95175 L5.28071735,18.77775 C4.28471735,19.38575 3.04971735,18.48775 3.32071735,17.35275 L4.57771735,12.07975 L0.46071735,8.55275 C-0.42628265,7.79275 0.0457173498,6.34075 1.20971735,6.24775 L6.61371735,5.81375 L8.69571735,0.80875 L8.69571735,0.80775 C8.93379735,0.235401429 9.47688698,-0.0327847592 10.0008046,0.00319143673 Z"></path>
                    </svg><svg viewBox="0 0 10 19" xmlns="http://www.w3.org/2000/svg" class="h-4 w-auto fill-gray-100">
                        <path fill-rule="evenodd" d="M1.11971735,0.804607549 L3.20171735,5.81060755 L8.60571735,6.24460755 C9.76971735,6.33760755 10.2417173,7.78960755 9.35471735,8.54960755 L5.23771735,12.0766075 L6.49471735,17.3496075 C6.76571735,18.4856075 5.53071735,19.3826075 4.53471735,18.7746075 L0,16.004 L8.84434086e-05,1.19032517e-14 C0.462291355,0.031492829 0.909688875,0.299695345 1.11971735,0.804607549 Z"></path>
                    </svg>
                  </span>
            </template>
        </div>
        <div class="font-bold text-sm text-gray-700">{{ rating.rating }}</div>
    </a>
</template>
